import jquery from "jquery/jquery-3.3.1.min";

jquery.noConflict();

export default jquery;
